import { useEffect, useState, useRef } from 'react';

import AuthService from '../../helpers/auth';
import {Auth} from '../../components/Auth/auth';

import { Table, Tag, Button, Input, Space, DatePicker, Popover, Dropdown, Switch, Checkbox } from 'antd';
import {ConfigProvider} from 'antd';
import { Col, Row } from 'antd';
import { 
    SearchOutlined, ReloadOutlined, LockOutlined, 
    UnlockOutlined, DownOutlined, FilterOutlined, 
    SortAscendingOutlined, 
    MobileOutlined, DesktopOutlined,
    SunOutlined, MoonOutlined,
    SettingOutlined, ToolOutlined,
    LoadingOutlined,
    FolderOutlined,
    EnvironmentOutlined
} from '@ant-design/icons';

import Highlighter from 'react-highlight-words';

import { loadAKB, parseAKB, round, loadDetailAKB, parseDetailAKB, loadDetailAKB_Soc, loadDetailAKB_Power, loadDetail_Signal, parseDetailSignal, ShowLocaleDateTime } from '../../helpers/helpers';
import References from '../../helpers/Reference';

import { chartLineOptions, chartBarOptions } from '../../helpers/chartoptions';
import { Line, Bar } from 'react-chartjs-2';

import { CustomDatepicker } from '../datepicker/custom.datepicker';
import './voltage.css';
import { filterAKB, formatExtraChannelsChart, getChartPath, getChartType, getExtraChannels, getProjectAreaView, getShortView, getTheme, prepareStartExtraChannel, saveAreaProject, saveShortView, saveTheme } from './utils';
import { loadAreas } from '../SearchStation/search.helper';

const RELOAD_INTERVAL = 10 * 60 * 1000;

const getAKBStateColor = (state) => {
    if (References.akbVoltageStates.hasOwnProperty(state))
        return References.akbVoltageStates[state];
    return References.akbVoltageStates.undefined;
}

const getSyncStateColor = (state, theme) => {
    const states = References.tsmSyncStates;
    if (!states.hasOwnProperty(state))
        return theme === 'dark' ? states.dark['default'] : states['default'];
    if (theme === 'dark')
        return states.dark.hasOwnProperty(state) ? states.dark[state] : states[state];
    return states[state];
}

const getSignalStateColors = ( state, theme ) => {    
    const states = References.akbSignalStates;
    if (theme === 'dark') 
        return {
            color: states.dark.hasOwnProperty(state) ? states.dark[state] : states[state]
        }

    return {
        bgColor: states[state],
        color: states.text_color.hasOwnProperty(state) ? states.text_color[state] : null
    }

}

const getVoltage = ( item, key, val ) => {
    if (item?.voltage12?.hasOwnProperty(key) && item.voltage12[key].hasOwnProperty(val))
        return item.voltage12[key][val];
    if (item?.voltage4?.hasOwnProperty(key) && item.voltage4[key].hasOwnProperty(val))
        return item.voltage4[key][val];

}

const getVoltageType = ( item ) => {
    if (item.hasOwnProperty('voltage12') && item.voltage12.hasOwnProperty('uuid'))
        return 'voltage12';
    if (item.hasOwnProperty('voltage4') && item.voltage4.hasOwnProperty('uuid'))
        return 'voltage4';
}

const getUUID = ( item ) => {
    if (item.hasOwnProperty('voltage12') && item.voltage12.hasOwnProperty('uuid'))
        return item.voltage12.uuid;
    if (item.hasOwnProperty('voltage4') && item.voltage4.hasOwnProperty('uuid')) 
        return item.voltage4.uuid;
}

const getAKBState = (item) => {
    if ( item?.voltage12?.hasOwnProperty('state'))
        return item.voltage12.state;
    if ( item?.voltage4?.hasOwnProperty('state'))
        return item.voltage4.state;
}

const getAKBPower = (item) => {
    if (item?.voltage12?.hasOwnProperty('power'))
        return item.voltage12.power;
    if (item?.voltage4?.hasOwnProperty('power'))
        return item.voltage4.power;

}

const getAKBDoor = (item) => {    
    let state;
    let time;
    if (item?.door && Object.keys(item.door).length) {
        let key = Object.keys(item.door)[0];
        state = item.door[key].hasOwnProperty('last_value') && item.door[key].last_value.hasOwnProperty('state') ? item.door[key].last_value.state : 0;
        time = item.door[key].last_value.time;        
    }
    if ( state == null )
        state = 'default';
    if ( time == null )
        time = 'unknown';

    return {
        "state": References.door_state.hasOwnProperty(state) ? state : 'default',
        "state_time": time != 'unknown' ? ShowLocaleDateTime( time ) : time,
        "state_text": References.door_state[state].text,
        "state_color": References.door_state[state].color
    }        

}

const IS_MOBILE = window.screen.width <= 576;

const SORT_DEFAULT_DISTRICT = {
    field: "district",
    order: "descend"
}

const SORT_DEFAULT_PROJECT = {
    field: "project",
    order: "descend"
}

export const Voltage = () => {

    const [ loaded, setLoaded ] = useState( false );
    const [ loading, setLoading ] = useState( false );
    const [ reloading, setReloading] = useState(false);

    const [ showDetail, setShowDetail ] = useState( false );
    const [ detail, setDetail ] = useState( {} );    

    const [ akb, setAKB ] = useState( [] );
    const [ filter, setFilter ] = useState({})
    const [ filteredAKB, setFilteredAKB ] = useState([]);

    const [ isAuth, setIsAuth ] = useState( AuthService.isAuth() );    

    const [theme, setTheme] = useState( getTheme() );
    const [isMaintained, setIsMaintained] = useState( true );
    const [isShortView, setIsShortView] = useState( getShortView() === 'short' );
    const [isProject, setIsProject] = useState( getProjectAreaView() === 'project');

    const [tableSorted, setTableSorted] = useState(isProject ? SORT_DEFAULT_PROJECT : SORT_DEFAULT_DISTRICT);
    const [tableFilter, setTableFilter] = useState({});

    const [detailChartType, setDetailChartType] = useState(null);

    //уникальные значения типов батарей
    const getAKBTypes = ( data ) => {
        let values = Object.values(data);
        return [...new Set(Array.from( values, ({type}) => type))];        
    }

    const getAKBProjects = ( data ) => {
        let values = Object.values(data);
        return [...new Set(Array.from( values, ({project}) => project))].sort((a, b) => {
            if (a === null && b !== null)
                return 1;
            if (a !== null && b === null)
                return -1;
            return a.localeCompare(b);
        });
    }

    //регионы-районы
    const getAKBRegions = ( data ) => {
        let result = {};
        data.forEach((item) => {
            if (item.area && item.district) {
                if (!result.hasOwnProperty(item.area))
                    result[item.area] = [];
                if (!result[item.area].includes(item.district))
                    result[item.area]?.push(item.district);
            }
        });
        return result;
    }

    const getCommonCellStyle = ( theme, state ) => {
        if (theme === 'dark') {
            const colors = getAKBStateColor(state);
            return {
                color: colors.hasOwnProperty('darkColor') ? colors.darkColor : colors.bgColor
            }
        };
    }

    //фильтр необходимо передать при автообновлении
    const reload = (forcedFilter) => {
        if (reloading)
            return;

        setReloading(true);
        loadAKB()
            .then((data) => {
                const akb =  parseAKB(data);
                setAKB( akb );

                const selectFilter = forcedFilter ?? filter;
                if (filter)
                    setFilteredAKB(filterAKB(akb, selectFilter));

                setReloading(false);
        });
    }

    const onReload = () => {
        reload();
    }

    const onChangeTheme = (theme) => {
        setTheme(theme);
        saveTheme(theme);
    }

    const onChangeShortView = ( checked ) => {
        setIsShortView( checked )  
        saveShortView( checked );      
    }

    const onChangeProjectArea = (type ) => {
        setIsProject( type === 'project' )
        saveAreaProject( type );        
        const currTableFilter = tableFilter;
        currTableFilter.akb_table_header_area = null;
        currTableFilter.akb_table_header_project_area = null;
        setTableFilter(currTableFilter);
    }

    const onMaintained = (flag) => {
        let currFilter = filter;
        if (!flag)        
            delete currFilter.maintained;
        else 
            currFilter.maintained = true;
        setIsMaintained(!isMaintained);
        setFilter(currFilter);
        setFilteredAKB(filterAKB(akb, currFilter));
    }

    const getTableTitle = () => {
        return (            
            <div className={`change-theme panel-${theme} hidden-in-mobile`}>
                <Space>
                    <div>
                    <Popover
                        placement="topLeft"
                        content={theme === 'dark' ? References.dictionary.turn_theme_light : References.dictionary.turn_theme_dark}
                        trigger="hover"
                    >    
                    {theme === 'dark' ? (
                        <SunOutlined size="large" onClick={() => onChangeTheme('light')}/>
                    ) : (
                        <MoonOutlined onClick={() => onChangeTheme('dark')} />
                    )}
                    </Popover>
                    </div>

                    <div className="ml-2">
                    <Popover
                        placement="topLeft"
                        content={!isMaintained ? References.dictionary.turn_maintained : References.dictionary.turn_maintained_all}
                        trigger="hover"
                    >
                    {isMaintained ? (                                            
                        <SettingOutlined onClick={() => onMaintained(false)}/>                                                                        
                    ) : (
                        <ToolOutlined onClick={() => onMaintained(true)} />                        
                    )}
                    </Popover>
                    </div>

                    <div className="ml-2 hidden-mobile">
                    <Popover
                        placement="topLeft"
                        content={isShortView ? References.dictionary.turn_view_long : References.dictionary.turn_view_short}
                        trigger="hover"
                    >    
                    {isShortView ? (
                        <DesktopOutlined onClick={() => {onChangeShortView(false)}}/>                            
                    ) : (
                        <MobileOutlined onClick={() => {onChangeShortView(true)}}/>                            
                    )}
                    </Popover>                        
                    </div>

                    <div className="ml-2 hidden-mobile">
                    <Popover
                        placement="topLeft"
                        content={isProject ? References.dictionary.turn_project_area : References.dictionary.turn_project_group}
                        trigger="hover"
                    >    
                    {isProject ? (
                        <EnvironmentOutlined onClick={() => {onChangeProjectArea('area')}}/>                            
                    ) : (
                        <FolderOutlined onClick={() => {onChangeProjectArea('project')}}/>                            
                    )}
                    </Popover>                        
                    </div>


                    <div className="ml-4">
                        <ReloadOutlined onClick={onReload}/>
                    </div>

                    {reloading && 
                        <div className="ml-2">
                            <LoadingOutlined />
                        </div>
                    }

                </Space>
            </div>
        )
    }

    useEffect(() => {
        if (isAuth) {        
            setLoading( true );
            loadAKB()
                .then((data) => {
                    const akb =  parseAKB(data);
                    setAKB( akb );

                    //фильтруем только обслуживаемые - по умолчанию
                    const filter = {maintained: true};
                    setFilter(filter);
                    setFilteredAKB(filterAKB(akb, filter));

                    setLoaded( true ); 
                    setLoading( false )                      
                    setInterval(reload, RELOAD_INTERVAL, filter);                                     
            });
        }
    }, [ isAuth ] );

    const akbData = (data) => {return data.map((item, idx) => {        
        return {
            uuid: getUUID( item ),
            station_uuid: item.station_uuid,
            type: getVoltageType( item ),
            area: item.area,
            district: item.district,
            key: `akblist_${item.sn}`,
            sn: item.sn,
            akb_type: item.type,
            name: item.name,
            station: item.station_name,
            maintained: item.maintained,
            project: item.project,

            night_check: new Date(getVoltage(item, 'night_value', 'time')).toLocaleDateString(
                References.locale, {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
            ),
            night_voltage: round(getVoltage(item, 'night_value', 'voltage'), 2),

            last_check: new Date(getVoltage(item, 'last_value', 'time')).toLocaleDateString(
                References.locale, {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
            ),
            last_voltage: round(getVoltage(item, 'last_value', 'voltage'), 2),

            soc: getVoltage(item, 'last_value', 'soc'),
            soc_state: getVoltage(item, 'last_value', 'soc_state'),
            soc_night: getVoltage( item, 'night_value', 'soc'),
            soc_night_state: getVoltage(item, 'night_value', 'soc_state'),            
            state: getAKBState(item),

            door: getAKBDoor(item),
            online: item.hasOwnProperty('online') && item.online.time ? 
                new Date(item.online.time).toLocaleDateString(
                    References.locale, {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
                ) : null,
            revision: item.hasOwnProperty('online') ? item.online.revision : null,                
            tech: item.tech,
            power: getAKBPower( item ),
            photo: item.photo,
            sync_time: item.tech?.hasOwnProperty('sync_time') ? ShowLocaleDateTime(item.tech.sync_time) : '',
            extra_channels: getExtraChannels(item)
        };
    })
}

const getFilterIcon = (filtered) => {
    let color = null;
    if (filtered)
        color = '#1677ff';
    else if (theme === 'dark')
        color = '#777';
    return (
        <FilterOutlined 
            style={{
                color: color
            }}
        />
    );
}  

const getSortedIcon = ( sorted ) => {
    let color = null;
    if (sorted.sortOrder)
        color = '#1677ff';
    else if (theme === 'dark')
        color = '#777';
    return (
        <SortAscendingOutlined
            style={{
                color: color
            }}
        />
    );
}

const getColumnWidth = (column) => {
    const view = IS_MOBILE || isShortView ? 'short' : 'full';
    const projectRegion = isProject ? 'project' : 'region'     
    return References.tsmTableColumnWidth[view][projectRegion][column];
}

const onFastSearch = (e, field) => {
    const term = e.target.value;
    let newFilter = filter;
     if (term.length === 0)
        delete (newFilter[field])
    else
        newFilter[field] = term;

     if (newFilter) {
        setFilteredAKB(filterAKB(akb, newFilter))
     }
     setFilter(newFilter);
}



const onChangeGeoFilter = (value, checked, selectedKeys, setSelectedKeys, geo) => {
    let result = [];
    let withChildrens = geo.hasOwnProperty(value) ? geo[value] : [];    
    withChildrens.push(value);

    if (checked) {
        result = selectedKeys.concat(withChildrens);
    }  else {
        result = selectedKeys.filter((val) => !withChildrens.includes(val));
    }
    setSelectedKeys(result);
}

const columns = [
    {
        title: 'SN',
        dataIndex: 'sn',
        key: 'akb_table_header_sn',
        width: getColumnWidth('sn'), 
        render: (text, record) => {
                return (
                <div style={getCommonCellStyle(theme, record.state)}>
                   {text}
                </div>
                )
        },

    },    
    {
        title: 'Тип',
        dataIndex: 'akb_type',
        key: 'akb_table_header_type',
        width: getColumnWidth('akb_type'),                
        hidden: IS_MOBILE,      
        filteredValue: tableFilter.akb_table_header_type || null,                  
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div className="filter-wrapper">                
                <Checkbox.Group value={selectedKeys} onChange={(checkedValues) => setSelectedKeys(checkedValues)}>                    
                <ul className="ul-list ul-table-filter">                    
                {getAKBTypes(akb).map((val, index) => {
                    return (                        
                        <li key={`item_filter_type_${val}`}>
                            <Checkbox value={val}>{val}</Checkbox>
                        </li>                        
                    )                                     
                })}
                </ul>                
                </Checkbox.Group>                                

                <div className="table-filter-footer">
                    <a onClick={() => {
                        clearFilters();
                    }}>очистить</a>
                    <Button type="primary" size="small" onClick={() => {                        
                        confirm();
                    }}>Ок</Button>
                </div>
            </div>
        ),        
        onFilter: (value, record) => {
            return record.akb_type === value;
        },      
        filterIcon: (filtered) => getFilterIcon(filtered),
        render: (text, record) => {
                return (
                <div style={getCommonCellStyle(theme, record.state)}>
                    {text}
                </div>
                )
        }                                        
    },  
    {
        title: 'Группы',
        dataIndex: 'project',
        key: 'akb_table_header_project_area',
        width: getColumnWidth('project'), 
        hidden: !isProject,
        filteredValue: tableFilter.akb_table_header_project_area || null,        
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => {
            return (
            <div className="filter-wrapper">                
                <Checkbox.Group value={selectedKeys} onChange={(checkedValues) => setSelectedKeys(checkedValues)}>                    
                <ul className="ul-list ul-table-filter ul-table-filter-with-footer" style={{maxHeight: "450px"}}>                    
                {getAKBProjects(akb).map((val, index) => {
                    return (                        
                        <li key={`item_filter_project_${val}`}>
                            <Checkbox value={val}>{val}</Checkbox>
                        </li>                        
                    )                                     
                })}
                </ul>                
                </Checkbox.Group>                                

                <div className="table-filter-footer">
                    <a onClick={() => {
                        clearFilters();
                    }}>очистить</a>
                    <Button type="primary" size="small" onClick={() => {                        
                        confirm();
                    }}>Ок</Button>
                </div>
            </div>
        )},        
        onFilter: (value, record) => {
            return record.project === value;
        },      
        filterIcon: (filtered) => getFilterIcon(filtered),  
        
        sorter: (a, b) => {       
            let sort = b?.project?.localeCompare(a?.project);            
            if (sort === 0)
                sort = a.state - b.state;
            if (sort === 0) 
                sort = a.station?.localeCompare(b?.station) !== 1;                

            return (
                sort
            )                              
            },
        sortDirections: ['descend'],
        sortOrder: isProject && (tableSorted?.field === 'project' || tableSorted?.field === 'district') && tableSorted.order,
        sortIcon: (sorted) => getSortedIcon(sorted),
        showSorterTooltip: { title: 'Отсортировать' },

        render: (text, record) => {
            return (
            <div style={getCommonCellStyle(theme, record.state)}>
                {text}
            </div>
            )
        }         
    },      
    {
        title: 'Регион',
        dataIndex: 'area',
        key: 'akb_table_header_area',
        width: getColumnWidth('area'),      
        hidden: isProject,          
        onFilter: (value, record) => (record.district === value || record.area === value),      
        filterIcon: (filtered) => getFilterIcon(filtered),
        filteredValue: tableFilter.akb_table_header_area || null,
        filterDropdown: ({selectedKeys, setSelectedKeys, confirm, clearFilters}) => {
            const geo = getAKBRegions( akb );
            const areas = Object.keys(geo)                
            return (
            <div className="filter-wrapper">                
                <Checkbox.Group value={selectedKeys}>                    
                <ul className="ul-list ul-table-filter ul-table-filter-with-footer" style={{maxHeight: "450px"}}>                    
                {areas.map((area, index) => {
                    let districtHTML = geo[area].map((district, index) => {
                        return (
                            <li key={`item_filter_district_${index}`} className="ml-2">
                                <Checkbox value={district} onChange={(e) => {onChangeGeoFilter(e.target.value, e.target.checked, selectedKeys, setSelectedKeys, geo)}}>{district}</Checkbox>
                            </li>
                        )
                    });
                    return (                        
                        <div key={`item_filter_${index}`}>
                            <li key={`item_filter_area_${index}`} className="b bg-color-eee">
                                <Checkbox value={area} onChange={(e) => {onChangeGeoFilter(e.target.value, e.target.checked, selectedKeys, setSelectedKeys, geo)}}>{area}</Checkbox>
                            </li> 
                            {districtHTML}                        
                        </div>
                    )                 
                    
                })}
                </ul>                
                </Checkbox.Group>                                

                <div className="table-filter-footer">
                    <a onClick={() => {
                        clearFilters();
                    }}>очистить</a>
                    <Button type="primary" size="small" onClick={() => {                        
                        confirm();
                    }}>Ок</Button>
                </div>
            </div>            
        )},
        render: (text, record) => {
                return (
                <div style={getCommonCellStyle(theme, record.state)}>
                    {text}
                </div>
                )
        }   
    },  
    {
        title: () => 
            <div>
                Район
                <input type="text" defaultValue={filter?.district} onClick={(e) => e.stopPropagation()} onKeyUp={(e) => onFastSearch(e, 'district')}/>
            </div>                
        ,
        dataIndex: 'district',
        key: 'akb_table_header_district',
        width: getColumnWidth('district'),                
        className: 'with-search',    
        hidden: isProject,    
        render: (text, record) => {
                return (
                <div style={getCommonCellStyle(theme, record.state)}>
                    {text}
                </div>
                )
        },
        sorter: (a, b) => {            
            let sort = a.area?.localeCompare(b?.area) !== 1; 
            if (sort === 0) 
                sort = a.district?.localeCompare(b?.district) !== 1;                
            if (sort === 0)
                sort = a.state - b.state;
            if (sort === 0) 
                sort = a.station?.localeCompare(b?.station) !== 1;                

            return (
                sort
            )                
         },
         sortOrder: !isProject && (tableSorted?.field === 'project' || tableSorted?.field === 'district') && tableSorted.order,         
         sortDirections: ['descend'],
         sortIcon: (sorted) => getSortedIcon(sorted),
         showSorterTooltip: { title: 'Отсортировать' },
    },      
    {
        title: () => 
            <div>
                Пост 
                <input type="text" defaultValue={filter?.station_name} onClick={(e) => e.stopPropagation()} onKeyUp={(e) => onFastSearch(e, 'station_name')}/>
            </div>                
        ,
        dataIndex: 'station',
        className: 'with-search',
        key: 'akb_table_header_station',
        width: getColumnWidth('station'),        
         render: (text, record) => {
                 return (
                 <div style={getCommonCellStyle(theme, record.state)}>
                     {text}
                 </div>
                 )
         },
         sorter: (a, b) => {
            return a.station.localeCompare(b.station);
         },
         sortIcon: (sorted) => getSortedIcon(sorted),
         sortOrder: tableSorted?.field === 'station' && tableSorted?.order,
         sortDirections: ["ascend", "descend", "ascend"],
         showSorterTooltip: { title: 'Отсортировать' },
    },  
    {
        title: 'Камера',
        key: 'akb_table_header_camera',
        width: getColumnWidth('cam'),        
        className: 'akb-bg-state',
        render: (text, record) => {
            if (record.photo) {
                const color = References.camStatuses.hasOwnProperty(record.photo.status) ? 
                    References.camStatuses[record.photo.status].bgcolor :
                    References.camStatuses["-1"].bgcolor
                const content = (
                    <div>
                        <div><div className="rem">Время измерения</div>{ShowLocaleDateTime(record.photo.last_value.time)}</div>
                        <div className="mt-1"><div className="rem">Время получения</div>{ShowLocaleDateTime(record.photo.last_value.time_received)}</div>
                    </div>                            
                );

                return (
                   <Popover
                        placement="topLeft"
                        content={content}
                        trigger="hover"
                    >                     
                    <div className={`akb-state-color`} style={
                        theme === 'dark' ?                        
                        {color: color} :
                        {backgroundColor: color}
                    }>
                        cam
                    </div>
                    </Popover>
                )    
            }
        }        
    },  

    {
        title: () => "Напряжение (В)",
        key: 'akb_table_header_voltage',
        width: getColumnWidth('voltage_night'),        
        className: 'akb-bg-state',   
        dataIndex: "last_voltage",
        filteredValue: tableFilter.akb_table_header_voltage || null,                
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div className="filter-wrapper">                
                <Checkbox.Group value={selectedKeys} onChange={(checkedValues) => setSelectedKeys(checkedValues)}>                    
                <ul className="ul-list ul-table-filter">                    
                {References.voltageStatuses.map((data) => {
                    const colors = getAKBStateColor(data.value);
                    return (                        
                        <li key={`item_filter_voltage_${data.value}`} style={{backgroundColor: colors.bgColor, color: colors.textColor}}>
                            <Checkbox value={data.value}>{data.text}</Checkbox>
                        </li>                        
                    )                 
                    
                })}
                </ul>                
                </Checkbox.Group>                                

                <div className="table-filter-footer">
                    <a onClick={() => {
                        clearFilters();
                    }}>очистить</a>
                    <Button type="primary" size="small" onClick={() => {                        
                        confirm();
                    }}>Ок</Button>
                </div>
            </div>
        ),
        onFilter: (value, record) => record.state === parseInt(value),                                        
        filterIcon: (filtered) => getFilterIcon(filtered),  
        
        sorter: (a, b) => {            
            let sort = a.state - b.state;
            if (!isProject) {
                if (sort === 0) 
                    sort = a.area?.localeCompare(b?.area) !== 1;                
                if (sort === 0) 
                    sort = a.district?.localeCompare(b?.district) !== 1;                
            } else {
                if (sort === 0)
                    sort = b?.project?.localeCompare(a?.project);
            }
            if (sort === 0) 
                sort = a.station?.localeCompare(b?.station) !== 1;                

            return (
                sort
            )                
         },
         sortOrder: tableSorted?.field === 'last_voltage' && tableSorted?.order,         
         sortDirections: ['descend'],
         sortIcon: (sorted) => getSortedIcon(sorted),
         showSorterTooltip: { title: 'Отсортировать' },
         children: [
            {
              title: "ночное",
              key: "akb_table_header_ngiht_voltage",
              dataIndex: "night_voltage",
              className: 'akb-bg-state', 
              width: getColumnWidth('voltage_day'),                      
              render: (text, record) => {
                let tagText = text;            
                if (record?.type && record?.soc_night)
                    tagText += ' (' +record.soc_night+ '%)';
    
                let colors = getAKBStateColor( record.state );                        
                return (
                   <Popover
                        placement="topLeft"
                        title="Время измерения"
                        content={record.night_check}
                        trigger="hover"
                    >                            
                        <div className='akb-state-color text-center'
                            style={                            
                                theme === 'dark' ? 
                                {color: colors.darkColor ? colors.darkColor : colors.bgColor} :
                                {backgroundColor: colors.bgColor, color: colors.textColor}
                            }
                        >
                            {tagText}
                        </div>
                    </Popover>
                )
            }            
            },
            {
              title: "последнее",
              key: "akb_table_header_last_voltage",
              dataIndex: "last_voltage",
              className: "akb-bg-state",
              width: getColumnWidth('voltage_day'),  
              render: (text, record) => {

                let tagText = text;            
                if (record?.type && record?.soc)
                    tagText += ' (' +record.soc+ '%)';

                let colors = getAKBStateColor( record.state );   
                return (
                <Popover
                        placement="topLeft"
                        title="Время измерения"
                        content={record.last_check}
                        trigger="hover"
                    >                
                        <div className='akb-state-color text-center' 
                            style={
                                theme === 'dark' ? 
                                {color: colors.darkColor ? colors.darkColor : colors.bgColor} :
                                {backgroundColor: colors.bgColor, color: colors.textColor}
                            }
                        >
                            {tagText}
                        </div>
                    </Popover>
                )
                }                                              
            }
          ]
          },
    {
        title: () => <LockOutlined className="text-llg d-block"/>,
        colspan: 0,
        className: "text-center",
        dataIndex: 'door',
        key: 'akb_door_table_header',
        width: getColumnWidth('door'),        
        hidden: isShortView || IS_MOBILE,
        render: ( door ) => {
            return (
                <>    
               <Popover
                    placement="topLeft"
                    title="Время измерения"
                    content={door.state_time}
                    trigger="hover"
                >
                    {door.state === 0 &&
                         <UnlockOutlined className="text-llg" style={{color: References.tsmDoorStates["0"]}}/>                          
                    }

                    {door.state === 1 &&                        
                         <LockOutlined className="text-llg" style={{color: References.tsmDoorStates["1"]}}/> 
                    }

                    {(door.state === -1 || typeof(door.state) === 'undefined' || door.state === 'default') &&
                         <LockOutlined className="text-llg" style={{color: References.tsmDoorStates["-1"]}}/> 
                    }
                    
                </Popover>
                </>
            )
        },
        filteredValue: tableFilter.akb_door_table_header || null,                
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
            <div className="filter-wrapper">                
                <Checkbox.Group value={selectedKeys} onChange={(checkedValues) => setSelectedKeys(checkedValues)}>                    
                <ul className="ul-list ul-table-filter">                    
                {References.doorStatuses.map((data) => {
                    return (                        
                        <li key={`item_filter_door_${data.value}`}>
                            <Checkbox value={data.value}>{data.text}</Checkbox>
                        </li>                        
                    )                                     
                })}
                </ul>                
                </Checkbox.Group>                                

                <div className="table-filter-footer">
                    <a onClick={() => {
                        clearFilters();
                    }}>очистить</a>
                    <Button type="primary" size="small" onClick={() => {                        
                        confirm();
                    }}>Ок</Button>
                </div>
            </div>
        ),

        filterIcon: (filtered) => getFilterIcon(filtered),        
        onFilter: (value, record) => record.door.state === value                                        
    },
    {
        title: 'Связь',
        dataIndex: 'name',
        colSpan: 3,
        key: 'akb_comm_table_header',
        width: getColumnWidth('signal_1'),        
        hidden: isShortView || IS_MOBILE,
        render: ( text, record ) => {
            const systemMode = record?.tech?.system_mode;
            if (!References.system_mode_name.hasOwnProperty(systemMode))
                return '—';

            return (
                <Popover
                    placement="topLeft"
                    title="Время измерения"
                    content={ShowLocaleDateTime(record.tech.time)}
                    trigger="hover"
                >
                    <div style={getCommonCellStyle(theme, record.state)}>{References.system_mode_name[systemMode]}</div>
                </Popover>                                                        
            ) 
        }                    
    },
    {
        title: 'RS',
        colSpan: 0,
        key: 'akb_comm_RS_table_hedaer',
        width: getColumnWidth('signal_2'),        
        className: 'akb-bg-state',
        hidden: isShortView || IS_MOBILE,        
        render: ( _, record ) => {
            const systemMode = record?.tech?.system_mode;
            if (systemMode !== 0 && systemMode !== 1)
                return ('—');

            const state = systemMode === 0 ? record.tech.rssi_state : record.tech.rsrp_state;
            const text = systemMode === 0 ? record.tech.rssi : record.tech.rsrp; 
            const colors = getSignalStateColors(state, theme);

            return (
                <>
                        
                        <Popover
                            placement="topLeft"
                            title="Время измерения"
                            content={ShowLocaleDateTime(record.tech.time)}
                            trigger="hover"
                        >
                        <div className='akb-state-color' 
                            style={
                                theme === 'dark' ? 
                                {color: colors.color} :
                                {backgroundColor: colors.bgColor, color: colors.color}
                            }
                        >
                        {text}
                        </div>
                        </Popover>                        

                </>
            )
        }
    },
    {
        title: 'RS state',
        colSpan: 0,
        key: 'akb_comm_RS_state_table_header',
        width: getColumnWidth('signal_3'),        
        className: 'akb-bg-state',   
        hidden: isShortView || IS_MOBILE,             
        render: (_, record) => {
            let systemMode = record.tech?.system_mode;            
            if (systemMode !== 1)
                return '—';

            const colors = getSignalStateColors(record.tech.rssnr_state, theme);
            return (
                <>
                    <Popover
                        placement="topLeft"
                        title="Время измерения"
                        content={ShowLocaleDateTime(record.tech.time)}
                        trigger="hover"
                    >
                    <div className='akb-state-color' 
                        style={
                            theme === 'dark' ? 
                            {color: colors.color} : 
                            {backgroundColor: colors.bgColor}
                            
                        }
                    >

                    {record.tech.rssnr}</div>
                    </Popover>                                                                            
                </>
            );                
        }
    },

    {
        title: 'Время синхронизации',
        dataIndex: 'sync_time',
        key: 'akb_sync_time_table_header',
        width: getColumnWidth('sync'),        
        className: 'akb-bg-state',  
        hidden: isShortView || IS_MOBILE,              
        render: (text, record) => {
            const colors = getSyncStateColor(record.tech?.sync_time_state, theme);
            return (
                <div className='akb-state-color display-linebreak' 
                    style={
                        theme === 'dark' ? 
                        {color: colors.textColor} :
                        {backgroundColor: colors.bgColor, color: colors.textColor}
                    }
                >{text}</div>
                

            )
        },        
    },

    {
        title: 'Выход на связь',
        dataIndex: 'online',
        key: 'akb_online_table_header',
        width: getColumnWidth('online'),        
        hidden: IS_MOBILE,
        render: (text, record) => {
            return (
            <div style={getCommonCellStyle(theme, record.state)}>
                {text}
            </div>
            )
    }}    
    ];

    const onRowClick = ( record ) => {
        setDetail( record );        
        setShowDetail( true );
        
    }

    const onCloseDetail = () => {
        setShowDetail( false );
    }

    const onLogin = () => {
        setIsAuth( true );            
    }

    const onLogout = () => {
        setIsAuth( false );            
        setLoaded( false );
    }

    const onTableChange = (pagination, filters, sorter) => {
        setTableFilter( filters );
        setTableSorted( sorter );
    }

    return (<>
        {loaded && 
            <div className={`voltage ${theme}`}>     

                {theme === 'dark' ? (
                <ConfigProvider           
                    theme={{
                        components: {
                            Table: {
                                borderColor: '#555555'
                            }
                        }                                  
                    }}                                
                >
                <Table
                    columns={columns}
                    dataSource={akbData(Object.keys(filter).length > 0 ? filteredAKB : akb)}
                    pagination={false}
                    scroll={{
                        y: showDetail ? "calc(60vh - 120px)": "calc(100vh - 120px)",
                        x: true
                    }}
                    size="small"
                    title={() => getTableTitle()}
                    className={`table-voltage ${theme}-theme`}
                    bordered
                    onChange={onTableChange}                    
                    tableLayout='fixed'
                    onRow={(record, rowIndex) => {
                        return {
                          onClick: (event) => { onRowClick( record ); }
                        };
                    }}            
                />
                </ConfigProvider>
                ) : (
                    <Table
                    columns={columns}
                    dataSource={akbData(Object.keys(filter).length > 0 ? filteredAKB : akb)}
                    pagination={false}
                    scroll={{
                        y: showDetail ? "calc(60vh - 120px)": "calc(100vh - 120px)",
                        x: true
                    }}
                    size="small"
                    title={() => getTableTitle()}
                    className={`table-voltage ${theme}-theme`}
                    bordered
                    onChange={onTableChange}
                    onRow={(record, rowIndex) => {
                        return {
                          onClick: (event) => { onRowClick( record ); }
                        };
                    }}            
                />

                )}
                {showDetail &&
                    <DetailVoltage 
                        visible={showDetail} 
                        akb={detail} 
                        detailChartType={detailChartType} 
                        onCloseDetail={onCloseDetail} 
                        onChangeDetailChartType={setDetailChartType} 
                    />
                }
            </div>            
        }

        {loading &&
            <div id="loading-screen" className="loading-wrapper loading">&nbsp;</div>
        }
        
        <Auth loginActions={[onLogin]} logoutActions={[onLogout]} area="voltage" param="close_area"/>            
    </>)
}

const DetailVoltage = ( {visible, akb, detailChartType, onCloseDetail, onChangeDetailChartType} ) => {    

    const GRID_LINES_AMOUNT = 10;

    const now = new Date().getTime() + 1000 * 3600 * 2;
    const prev = now - 1000 * 60 * 60 * 24;    

    const [start, setStart] = useState( new Date(prev).toLocaleString(References.locale) );
    const [finish, setFinish] = useState( new Date(now).toLocaleString(References.locale) );

    const [chartData, setChartData] = useState([]);  
    const [chartType, setChartType] = useState(null);
    const [chartName, setChartName] = useState(null);    

    const [ isHasTech, setIsHasTech] = useState(false);
    const [ isHasEnergy, setIsHasEnergy] = useState(false);
    
    const [loading, setLoading] = useState(true);

    useEffect(() => {        
        const chartPath = getChartPath(detailChartType)        

        //не для всех комплексов показываем график СИГНАЛ        
        const isHasTech = akb.tech.hasOwnProperty('uuid');        
        setIsHasTech( isHasTech );
        if ( !isHasTech &&  chartPath === 'signal')
            detailChartType = null;

        //не показываем график энергия для 4V
        const isHasEnergy = akb?.type !== 'voltage4';
        setIsHasEnergy(isHasEnergy);
        if (!isHasEnergy && chartPath === 'power')
            detailChartType = null;

        //если на посту нет датчиков дистанции до воды, а запрошен такой датчик, то сбрасываем
        //иначе устанавливаем первый из списка каналов
        if (References.tsmExtraMCHS.hasOwnProperty(chartPath)) 
            detailChartType = prepareStartExtraChannel(akb.extra_channels, chartPath)

         if (akb.uuid && akb.type ) { 
            ShowChart( detailChartType )
        }
    }, [akb] );

    const onClose = () => {
        onCloseDetail();
    }

    const onStartOk = ( value ) => {
        setStart( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
    }

    const onFinishOk = ( value ) => {
        setFinish( new Date(value.$y, value.$M, value.$D, value.$H).toLocaleString(References.locale))
    }

    const ShowVoltageChart = () => {
        setLoading(true);
        loadDetailAKB( akb.type, akb.uuid, start, finish )
        .then(data => {
            let chartData = parseDetailAKB(data, akb.type);
            setChartData(chartData); 
            setLoading(false);             
        });        
    }

    const ShowSocChart = () => {
        setLoading(true);        
        loadDetailAKB_Soc( akb.type, akb.uuid, start, finish )
        .then( data => {
                let chartData = parseDetailAKB(data, akb.type, 'soc');
                setChartData(chartData); 
                setLoading(false);                
        })
    }

    const ShowPowerChart = () => {    
        setLoading(true);        
        let start = new Date(now - 1000 * 60 * 60 * 24 * 180).toLocaleString(References.locale); 
        loadDetailAKB_Power( akb.type, akb.uuid, start, finish )
        .then( data => {
            const chartData = parseDetailAKB(data, akb.type, 'power_delta');
            setChartData(chartData );   
            setLoading(false);            
            
        })
    }

    const ShowSignalChart = () => {    
        setLoading(true);        
        loadDetail_Signal( akb.tech.uuid, start, finish )
        .then( data => {            
                let chartData = parseDetailSignal( data );
                setChartData(chartData);    
                setLoading(false);                
        })
    }

    const ShowWaterLevelChart = (type, uuid ) => {
        setLoading(true);
        loadDetailAKB( type, uuid, start, finish )
        .then(data => {            
            let chartData = parseDetailAKB(data, type, References.sensors[type].field);
            setChartData(chartData); 
            setLoading(false);             
        });        
    }

    const ShowChart = ( chartJSON ) => {
        try {
            const json = JSON.parse(chartJSON);
            switch (json.path) {
                case 'soc':
                    ShowSocChart();
                break;
                case 'power':
                    ShowPowerChart();
                break;
                case 'signal':
                    ShowSignalChart();
                break;

                case 'rldistance':
                case 'usdistance':                
                case 'hsdistance':
                case 'lzdistance':
                    ShowWaterLevelChart(json.path, json.uuid)
                break;
                default: 
                    ShowVoltageChart()                
                break;
            }
        } catch (e) {                    
            ShowVoltageChart()            
        }  finally {
            //при показе графика могут прийти новые данные по типу графика и идетификатору,
            //например, при открытии нового поста
            onChangeDetailChartType(chartJSON);            

            setChartType(chartJSON);            
            setChartName(getChartTypeName(chartJSON))            
        }      
    }

    const onShowChartClick = () => {
        ShowChart( chartType );
    }

    const setLineChartOptions = () => {
        let type = akb.type;
        let chartOptions = chartLineOptions();

        //скрываем даты 
        chartOptions.scales.x.ticks = {
            display: false,
            maxTicksLimit: GRID_LINES_AMOUNT
        };

        //устанавливаем min-max для оси y
        switch (getChartPath(chartType)) {
            case 'soc':
                chartOptions.scales.y.max = 100;
                chartOptions.scales.y.min = 0;                        
            break;
            case 'power':
                chartOptions.scales.y.max = 5;
                chartOptions.scales.y.min = 0;                                    
            break;
            case 'rldistance':
            case 'usdistance':                
            case 'hsdistance':
            case 'lzdistance':
                const max = Math.max(...chartData.data);
                const min = Math.min(...chartData.data);
                chartOptions.scales.y.max = Math.max(max + Math.abs(max) * 0.2);
                chartOptions.scales.y.min = Math.min(min - Math.abs(min * 0.2));        
            break;
            default:
                chartOptions.scales.y.max = type == "voltage12" ? 16 : 6;
                chartOptions.scales.y.min = type == "voltage12" ? 10 : 2;            
            break;            
        }

        return chartOptions;
    }

    const setBarChartOptions = () => {
        let chartOptions = chartBarOptions();

        chartOptions.scales.x.ticks = {
            display: false,
            maxTicksLimit: GRID_LINES_AMOUNT
        };
        switch (getChartPath(chartType)) {                        
            case 'power':
                const max = Math.max(...chartData.data);
                const min = Math.min(...chartData.data);

                chartOptions.scales.y.max = Math.max(1, max + max * 0.2);
                chartOptions.scales.y.min = Math.min(-1, min - Math.abs(min * 0.2));        
            break;

            case 'signal':
                chartOptions.scales.x.stacked = true;            
                chartOptions.scales.y.stacked = true;  
                chartOptions.plugins.tooltip.callbacks = {
                    beforeTitle: function( context ) {
                        if (context.length > 0)
                            return chartData.operator[context[0].dataIndex];
                    }
                }                                          
            break;
        }
        return chartOptions;
    }

    const chartBarStateColors = ( data ) => {
        let stateColors = References.akbSignalStates;        
        if ( Array.isArray(data)) {
            let colors = data.map( state => {
                if (stateColors.hasOwnProperty(state))                
                    return stateColors[state];
                return stateColors["0"];
            })
            return colors;
        }        
        return stateColors[0];
    }

    const signalBarChartOptionsPattern = () => {
        return {
            "fill": false,
            "pointRadius": 0,
            "borderColor": '#fff',
            "borderSkipped": 'right',
            "backgroundColor": 'blue',
            "borderWidth": 1,
            "spanGaps": false,
            "barPercentage": 1,
            "categoryPercentage": 1,                                    
            "data": []
        }
    }

    const getSignalDatasets = () => {        
        if (chartData.hasOwnProperty('signal') && Array.isArray(chartData.signal) ) {  
            let datasets = chartData.signal.map( data => {

                let dataset = signalBarChartOptionsPattern();
                dataset.data = data.values;
                dataset.backgroundColor = chartBarStateColors( data.states );
                return dataset;                        
            });     
            return datasets;
        } else {
            return [signalBarChartOptionsPattern()];
        }
    }

    const getPowerChartBgColor = () => {
        return chartData.data.map(value => {
            return value < 0 ? '#a00' : 'blue';                        
        }); 
    }

    const onChartTypeClick = ( item ) => {        
        ShowChart(item.key);            
    }

    const getChartTypeName = ( chartType ) => {
        const filter = chartTypeItems.filter(item => item.key === chartType);
        return filter.length ? filter[0].label : chartTypeItems[0].label;
    }

    const getChartTtypesItems = () => {
        let items = [
        {
            label: "Напряжение, В",
            key: JSON.stringify({path: "voltage"})
        },
        {
            label: "Заряд, %",
            key: JSON.stringify({path: "soc"})
        }]

        if (isHasEnergy) {
            items.push({
                label: "Энергия кВт/мес",
                key: JSON.stringify({path: "power"})
            })
        }        

        if (isHasTech)
            items.push({
                label: "Связь, дБ",
                key: JSON.stringify({path: "signal"})
            });
        if (akb?.extra_channels.length > 0) 
            items.push(...formatExtraChannelsChart(akb.extra_channels))
        return items;
    }
    const chartTypeItems = getChartTtypesItems();

    return (
        <>
        { visible && 
        <div className={"pos-relative detail-voltage" + (visible ? "" : " d-none")}>
            <span className="close" onClick={onClose}>&times;</span>
                <Row>
                    <Col xs={24} lg={12} className="pos-relative">
                        <div className="title">
                            {akb.name}, {akb.sn}
                        </div>                
                        <div className="mt-1">
                            <CustomDatepicker isCustom={false} start={start} finish={finish} onStart={onStartOk} onFinish={onFinishOk}/>                                                                
                            <Button className="ml-2" type="default" shape="circle" icon={<ReloadOutlined />} onClick={onShowChartClick} />
                            <Dropdown
                                menu={{items: chartTypeItems, onClick: onChartTypeClick}}
                                trigger={['click']}
                            >
                                <span onClick={(e) => e.preventDefault()} className="cursor-pointer ml-2">
                                    <Space>
                                        {chartName}
                                        <DownOutlined />
                                    </Space>
                                </span>
                            </Dropdown>

                        </div>

                        {!loading && 
                        <div className="mt-1">
                            {getChartPath(chartType) === 'power' ? 
                                <Bar
                                    data={
                                        {labels: chartData.labels,
                                        datasets: [
                                            {
                                                fill: false,
                                                pointRadius: 0,
                                                borderColor: '#fff',
                                                borderSkipped: 'right',
                                                backgroundColor: getPowerChartBgColor(),
                                                borderWidth: 1,
                                                spanGaps: false,
                                                barPercentage: 1,
                                                categoryPercentage: 1,                                    
                                                data: chartData.data,

                                            }
                                        ]
                                    }}
                                    options={setBarChartOptions()}
                                    redraw={true}
                                />
                                : 
                                getChartPath(chartType) === 'signal' ? 
                                <Bar
                                    data={{
                                            labels: chartData.labels,
                                            datasets: getSignalDatasets()
                                    }}
                                    options={setBarChartOptions()}
                                    redraw={true}
                                />
                                :
                                    <Line
                                        data={
                                            {labels: chartData.labels,
                                            datasets: [
                                                {
                                                    fill: false,
                                                    pointRadius: 0,
                                                    backgroundColor: "#00a",
                                                    borderColor: "#00a",
                                                    borderWidth: 1,
                                                    spanGaps: false,
                                                    data: chartData.data
                                                }
                                            ]
                                        }}
                                        options={setLineChartOptions()}
                                        redraw={true}
                                        />
                                }
                            
                        </div>
                        }
                        
                        {loading &&                                
                        <div className="loading voltage"></div>
                        }

                   </Col>
                    <Col xs={24} lg={12}>
                        { akb.hasOwnProperty('tech') && 
                        <div>                            
                        <div className="title">Общая информация</div>
                        <Row className="mt-1">
                            <Col span={6} className="border-tl-555 p-1">Имя</Col>
                            <Col span={18} className="border-tlr-555 p-1">{akb.name}</Col>
                        </Row>

                        <Row>
                            <Col span={6} className="border-tl-555 p-1 rem">Напряжение, В</Col>
                            <Col span={6} className="border-tl-555 p-1 text-right"  style={{backgroundColor: getAKBStateColor(akb.state).bgColor, color: getAKBStateColor(akb.state).textColor}}>
                            <Popover
                                placement="topLeft"
                                title="Время измерения"
                                content={akb.last_check}
                                trigger="hover"
                            >
                                <div>{akb.last_voltage}</div>
                            </Popover>                                                                            

                                
                            </Col>

                            { akb.tech.system_mode == 0 ? 
                                (
                                    <>                                        
                                    <Col span={6} className="border-tl-555 p-1 rem">RSSI, дБ</Col>
                                    <Col span={6} className="border-tlr-555 p-1 text-right" style={{backgroundColor: References.akbSignalStates[akb.tech.rssi_state], color: References.akbSignalStates.text_color[akb.tech.rssi_state]}}>
                                        <Popover
                                            placement="topLeft"
                                            title="Время измерения"
                                            content={ShowLocaleDateTime(akb.tech.time)}
                                            trigger="hover"
                                        >
                                            <div>{akb.tech.rssi}</div>
                                        </Popover>                                      </Col>
                                    </>
                                ) : 
                                (
                                    <>
                                    <Col span={6} className="border-tl-555 p-1 rem">RSRP/RSSNR, дБ</Col>
                                    <Col span={3} className="border-tl-555 p-1 text-right" style={{backgroundColor: References.akbSignalStates[akb.tech.rsrp_state], color: References.akbSignalStates.text_color[akb.tech.rsrp_state]}}>
                                        <Popover
                                            placement="topLeft"
                                            title="Время измерения"
                                            content={ShowLocaleDateTime(akb.tech.time)}
                                            trigger="hover"
                                        >
                                            <div>{akb.tech.rsrp}</div>
                                        </Popover>                                                                            
                                    </Col>
                                    <Col span={3} className="border-tlr-555 p-1 text-right" style={{backgroundColor: References.akbSignalStates[akb.tech.rssnr_state], color: References.akbSignalStates.text_color[akb.tech.rssnr_state]}}>
                                        <Popover
                                            placement="topLeft"
                                            title="Время измерения"
                                            content={ShowLocaleDateTime(akb.tech.time)}
                                            trigger="hover"
                                        >
                                            <div>{akb.tech.rssnr}</div>
                                        </Popover>                                                                            

                                        
                                    </Col>                                                                        
                                    </>                                    
                                )
                            }
                        </Row>

                        <Row>
                            <Col span={6} className="border-tl-555 p-1 rem">Заряд АКБ, %</Col>
                            <Col span={6} className="border-tl-555 p-1 text-right">
                            <Popover
                                placement="topLeft"
                                title="Время измерения"
                                content={akb.last_check}
                                trigger="hover"
                            >
                                <div>{akb.soc}</div>
                            </Popover>                                                                                                            
                            </Col>

                            <Col span={6} className="border-tl-555 p-1 rem">RSSI станции, дБ</Col>
                            <Col span={6} className="border-tlr-555 p-1 text-right">
                                <Popover
                                    placement="topLeft"
                                    title="Время измерения"
                                    content={ShowLocaleDateTime(akb.tech.time)}
                                    trigger="hover"
                                >
                                    <div>{akb.tech.signal_station}</div>
                                </Popover>                                  
                            </Col>
                        </Row>

                        <Row>
                            <Col span={6} className="border-tl-555 p-1 rem">Энергия, кВт/мес</Col>
                            <Col span={6} className="border-tl-555 p-1 text-right">
                                {typeof (akb.power) !== 'undefined' ? (
                                    <Popover
                                        placement="topLeft"
                                        title="Время измерения"
                                        content={ShowLocaleDateTime(akb.power.time)}
                                        trigger="hover"
                                    >
                                        <div>{akb.power.power_delta + ' (' +akb.power.power_gen+ ' - ' +akb.power.power_con+ ')'}</div>
                                    </Popover>                                                                            

                                    ) : '—'
                                }
                            </Col>                            

                            <Col span={6} className="border-tl-555 p-1 rem">Оператор</Col>
                            <Col span={6} className="border-tlr-555 p-1 text-right">
                                <Popover
                                    placement="topLeft"
                                    title="Время измерения"
                                    content={ShowLocaleDateTime(akb.tech.time)}
                                    trigger="hover"
                                >
                                    <div>{akb.tech.operator}</div>
                                </Popover>                                  
                            </Col>
                        </Row>

                        <Row>
                            <Col span={6} className="border-tl-555 p-1 rem">Версия ПО</Col>
                            <Col span={6} className="border-tl-555 p-1 text-right">
                                <Popover
                                    placement="topLeft"
                                    title="Время измерения"
                                    content={akb.online}
                                    trigger="hover"
                                >
                                    <div>{akb.revision}</div>
                                </Popover>                                  
                            </Col>

                            <Col span={6} className="border-tl-555 p-1 rem">Версия модема</Col>
                            <Col span={6} className="border-tlr-555 p-1 text-right">
                                <Popover
                                    placement="topLeft"
                                    title="Время измерения"
                                    content={ShowLocaleDateTime(akb.tech.time)}
                                    trigger="hover"
                                >
                                    <div>{akb.tech.modem_version}</div>
                                </Popover>                                  
                            </Col>                    
                        </Row>

                        <Row>
                            <Col span={24} className="border-555 p-1">
                                <Popover
                                    placement="topLeft"
                                    title="Время измерения"
                                    content={ShowLocaleDateTime(akb.tech.time)}
                                    trigger="hover"
                                >
                                    <div>{akb.tech.cpsi}</div>
                                </Popover>                                  

                            </Col>                            
                        </Row>
                        </div>
                        }

                    </Col>
            </Row>                               
        </div>
    }
    </>);
}